export default __webpack_public_path__ + "static/media/join_community_lines.2a11c03a.svg";